import { inject, Injectable } from '@angular/core';
import { StatusHistory } from '../models/status-history.model';
import { StatusHistoryMapper } from '../mappers/status-history.mapper';
import { HistoryStatus } from '../../sales/enums/history-status.enum';
import { GuidGeneratorService } from '@shared/tools/guid-generator.service';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class StatusHistoryService {
  private readonly _serviceKey = 'kfmStatusHistory';
  private readonly _blazorService = inject(HsBlazorService);
  private readonly _mapper = new StatusHistoryMapper();
  private readonly _guidGenerator = inject(GuidGeneratorService);

  public async create(
    value: StatusHistory,
  ): Promise<StatusHistory | undefined> {
    const request = this._mapper.mapStatusHistoryRequest(value);
    const result = await this._blazorService.invokeService(
      this._serviceKey,
      'Put',
      request,
    );

    if (result) {
      const id = (result as Record<string, unknown>)['id'] as string;
      value.uId = id;
      return value;
    }

    return undefined;
  }

  public getTemplate(
    userName: string,
    status: string | HistoryStatus,
    taskId: string,
  ): StatusHistory {
    let historyStatus: HistoryStatus;

    if (typeof status === 'string')
      historyStatus = this._mapper.getByGuid(status);
    else historyStatus = status;

    const statusHistoryData: StatusHistory = {
      concurrencyIdentificator: this._guidGenerator.emptyUUID,
      concurrencyStamp: new Date().toISOString(),
      stampCreate: new Date().toISOString(),
      syncType: 1,
      tenantUId: this._guidGenerator.emptyUUID,
      userUId: this._guidGenerator.emptyUUID,
      uId: this._guidGenerator.emptyUUID,
      employeeDesc: userName,
      infoDesc: this._mapper.getLongDesc(historyStatus),
      shortDesc: this._mapper.getShortDesc(historyStatus),
      taskId: taskId,
      statusId: this._mapper.getGuid(historyStatus),
    };

    return statusHistoryData;
  }

  // public async createOpenStatusForProcess(process: TaskDTO) {
  //   if (
  //     !!process &&
  //     !!process.statusHistory &&
  //     process.statusHistory.length <= 1 &&
  //     !process.statusHistory.map((s) => s.statusId).includes(STATUS_OFFEN) &&
  //     !process.statusHistory
  //       .map((s) => s.statusId)
  //       .includes(STATUS_OFFEN.toLowerCase())
  //   ) {
  //     var userName: string = await this._authHandler.getEmployeeName();
  //     var statusHistoryData = this.getTemplate(
  //       userName,
  //       STATUS_OFFEN,
  //       process,
  //       undefined,
  //     );
  //     var result: StatusHistoryDTO | undefined =
  //       await this.create(statusHistoryData);

  //     if (!!result) {
  //       !!process.statusHistory
  //         ? process.statusHistory.push(result)
  //         : (process.statusHistory = [result]);
  //     }
  //   }
  // }
}
